// theme.js
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "rgba(230, 100, 0, 1)", // Couleur principale
    },
    secondary: {
      main: "#00ff44", // Couleur secondaire
    },
    // background: {
    //   default: "rgba(224, 226, 229, 1)",
    // },
    google: {
      main: "#DB4A39",
    },
  },
  typography: {
    h2: {
      fontWeight: "bold",
      color: "rgba(230, 100, 0, 1)",
      fontFamily: "Caprasimo",
    },
  },

  components: {
    MuiTab: {
      styleOverrides: {
        root: {
          fontFamily: "Caprasimo",
          "&.Mui-selected": {
            background: "rgba(230, 100, 0,0.5)",
            color: "white",
          },
        },
      },
    },

    MuiAvatar: {
      styleOverrides: {
        root: {
          backgroundColor: "rgba(230, 100, 0, 1)",
          color: "white",
        },
      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 15,
        },
        containedGoogle: {
          color: "white", // Couleur du texte pour la prop color="google"
          "&:hover": {
            backgroundColor: "#BF3928", // Une nuance un peu plus foncée pour le survol
          },
        },
      },
    },
  },
});

export default theme;
